import { CELESTIAL_RIG_VERSION, celestialProportions, celestialStandardHeight, morphCelestialProportions } from '../../../content/characters/rigs/celestial.js';
import type { UnitDefinition } from '../../../shared/game/world-types.js';
import { mix } from '../../../content/characters/rigs/human.js';
import { createHumanoidModel, type HumanModelOptions } from './human-model.js';
import { addCelestialRaiment, shiningEyes } from './celestial-raiment.js';

/** Celestial anatomy is a morph of the shared humanoid assembly, with its own face, folded wings, a halo and shining gold eyes. */
export function createCelestialModel(definition: UnitDefinition, options?: HumanModelOptions) {
  const look = definition.appearance;
  if (!look || look.ancestry !== 'celestial') throw new Error('The Celestial model requires Celestial appearance content.');
  const p = morphCelestialProportions(celestialProportions(look.rig), look.parts?.face);
  const rig = createHumanoidModel({ ...definition, appearance: { ...look, height: look.height ?? celestialStandardHeight(p.id) } }, p, options,
    { face: p.face, palette: { eye: 0xe6bf62, lips: mix(look.skin, 0x8a5560, .28) } });
  rig.root.userData.nimblezRigVersion = CELESTIAL_RIG_VERSION;
  if (!options?.headless) { addCelestialRaiment(rig, look.hair); shiningEyes(rig.root); }
  return rig;
}
